import React, { Suspense, useEffect, useState } from 'react';
import { HashRouter } from 'react-router-dom';
import { App as AntdApp } from 'antd';
import { UIKitProvider, useClient } from 'easemob-chat-uikit';
import 'easemob-chat-uikit/style.css';

import { Loading } from '@/base/GlobalLoading';
import RenderRouter from '@/base/RenderRouter';
import ConfigProvider from '@/components/ConfigProvider';
import { normalRoutes } from '@/routes';
import { useChatSync } from '@/hooks/useChatSync';
import { userStore } from '@/store';
import { userApi } from '@/api/im';
import { usePersonalizationStore } from '@/store/personalization';
import { THEME_COLOR } from '@/config/appConfig';

// 内部组件：处理消息同步
const AppContent: React.FC = () => {
  const client = useClient();
  const userId = 'test222'; // TODO: 从用户登录状态动态获取

  // 启用消息同步
  useChatSync(client?.user ? userId : undefined);

  return (
    <AntdApp className="w-full h-full">
      <HashRouter>
        <Suspense fallback={<Loading />}>
          <RenderRouter routes={normalRoutes} />
        </Suspense>
      </HashRouter>
    </AntdApp>
  );
};

const App: React.FC = () => {
  const [imUserInfo, setImUserInfo] = useState('');
  const { userInfo } = userStore();
  const themeColor = usePersonalizationStore(s => s.themeColor);

  useEffect(() => {
    // 检查用户是否已登录
    if (!userInfo?.token) {
      console.log('用户未登录，无法获取 IM Token');
      return;
    }

    // 用户已登录，获取 IM Token
    userApi
      .imUserToken({}, { noMessage: false })
      .then((res: { value: string }) => {
        setImUserInfo(res.value);
        console.log('IM Token 获取成功');
      })
      .catch((error: any) => {
        console.error('获取 IM Token 失败:', error);
      });
  }, [userInfo?.token]); // 监听登录状态变化
  return (
    <ConfigProvider>
      <UIKitProvider
        initConfig={{
          appKey: '1162260116193259#demo',
          userId: userInfo?.shopId,
          token: imUserInfo,
        }}
        local={{
          lng: 'zh', // 设置界面语言为中文
        }}
        theme={{
          primaryColor: themeColor || THEME_COLOR,
        }}
      >
        <AppContent />
      </UIKitProvider>
    </ConfigProvider>
  );
};

export default App;
